import {ActorBypassMode} from '../bypass-actors-types'

export const UNSUPPORTED_BYPASS_MODES_BY_ACTOR_TYPE: Record<string, ActorBypassMode[]> = {
  DeployKey: [ActorBypassMode.PRS_ONLY],
  RepositoryMigration: [ActorBypassMode.PRS_ONLY],
}

/** Full mode label shown inside the mode-selection menu. */
export const bypassModeToText: Record<ActorBypassMode, string> = {
  [ActorBypassMode.ALWAYS]: 'Always',
  [ActorBypassMode.PRS_ONLY]: 'For pull requests only',
  [ActorBypassMode.EXEMPT]: 'Exempt',
}

/** Condensed mode label shown inline on a bypass row. */
export const bypassModeToShortDesc: Record<ActorBypassMode, string> = {
  [ActorBypassMode.ALWAYS]: 'Always allow',
  [ActorBypassMode.PRS_ONLY]: 'Allow for pull requests only',
  [ActorBypassMode.EXEMPT]: 'Exempt',
}
